import React, { useState } from 'react';
import { Box, Divider, Grid, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material';
// import WalletsPage from "../Components/FlokiTools/Wallets/wallet.component.jsx";
// import Tasks from '../Components/FlokiTools/Tasks/Tasks.component.jsx';

function App() {
  const [selectedTab, setSelectedTab] = useState('Tasks');

  const renderPage = () => {
    switch (selectedTab) {
      case 'Tasks':
        // return <Tasks />;
      case 'Wallets':
        // return <WalletsPage />;
      default:
        // return <Tasks />;
    }
  };

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      {/* Sidebar: Full width on small screens, 3 columns on medium+ */}
      <Grid
        item
        xs={12}
        md={2}
        sx={{
          // backgroundColor: 'rgba(255, 255, 255, 0.05)',
          p: 2,
          borderRight: { md: '1px solid rgba(255,255,255,.1)' }
        }}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton
              selected={selectedTab === 'Tasks'}
              onClick={() => setSelectedTab('Tasks')}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: (theme) => theme.palette.secondary.main,
                  color: (theme) => theme.palette.secondary.contrastText,
                },
                '&.Mui-selected:hover': {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                }

              }}
            >
              <ListItemText primary="Tasks" />
            </ListItemButton>
          </ListItem>
          <Box sx={{ my: 1 }} />
          <ListItem disablePadding>
            <ListItemButton
              selected={selectedTab === 'Wallets'}
              onClick={() => setSelectedTab('Wallets')}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: (theme) => theme.palette.secondary.main,
                  color: (theme) => theme.palette.secondary.contrastText,
                },
                '&.Mui-selected:hover': {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                }
              }}
            >
              <ListItemText primary="Wallets" />
            </ListItemButton>
          </ListItem>
        </List>
      </Grid>

      {/* Main Content Area: Full width on small screens, 9 columns on medium+ */}
      <Grid item xs={12} md={10} sx={{ p: 2 }}>
        {renderPage()}
      </Grid>
    </Grid>
  );
}

export default App;
